import script from "./BaseButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseButton.vue?vue&type=script&setup=true&lang=ts"

import "./BaseButton.vue?vue&type=style&index=0&id=68a75708&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a75708"]])

export default __exports__